import { useTranslation } from "react-i18next";

import { formatCount } from "../../../../shared/components/reports";
import type { ReportSubjectRow } from "../../domain/PractitionerReport";

/** The column's heading, with what it counts on hover. */
export function ModuleCoverageHeading({ className }: { className: string }) {
    const { t } = useTranslation();
    return (
        <th scope="col" className={className} title={t("reports.table.moduleCoverageHint")}>
            {t("reports.table.moduleCoverage")}
        </th>
    );
}

/** "75 % 3/4": the share of the course's modules a student covered. */
export function ModuleCoverageCell({ row, className }: { row: ReportSubjectRow; className: string }) {
    const { i18n } = useTranslation();
    const count = (value: number) => formatCount(value, i18n.language);
    return (
        <td className={className}>
            {row.modules_total ? (
                <>
                    {count(row.module_coverage_percent ?? 0)} %
                    <span className="ml-1.5 text-xs text-content-tertiary">
                        {count(row.modules_covered ?? 0)}/{count(row.modules_total)}
                    </span>
                </>
            ) : (
                "—"
            )}
        </td>
    );
}
